<div class="wrapper--stat-menu">
  <div class="row--stat-menu"
       (mouseenter)="onMouseOver('common')"
       (mouseleave)="onMouseLeave('common')"
       (click)="linkClicked('common')">
    <div class="icon-span--stat-menu link-div-column1--stat-menu">
      <img [src]="common_image" *ngIf="active_url !== 'commontable'">
      <img [src]="active_common_image" *ngIf="active_url === 'commontable'">
    </div>
    <div class="link-div-column2--stat-menu text--stat-menu" [ngClass]="{'active--stat-menu': active_url === 'commontable'}">
      Общая таблица
    </div>
  </div>
  <div class="row--stat-menu"
       (mouseenter)="onMouseOver('summary')"
       (mouseleave)="onMouseLeave('summary')"
       (click)="linkClicked('summary')">
    <div class="icon-span--stat-menu link-div-column1--stat-menu">
      <img [src]="summary_image" *ngIf="active_url !== 'summary'">
      <img [src]="active_summary_image" *ngIf="active_url === 'summary'">
    </div>
    <div class="link-div-column2--stat-menu text--stat-menu" [ngClass]="{'active--stat-menu': active_url === 'summary'}">
      Сводные данные
    </div>
  </div>
  <div class="row--stat-menu"
       (mouseenter)="onMouseOver('individual')"
       (mouseleave)="onMouseLeave('individual')"
       (click)="linkClicked('individual')">
    <div class="icon-span--stat-menu link-div-column1--stat-menu">
      <img [src]="individual_image" width="14px" *ngIf="active_url !== 'individual'">
      <img [src]="active_individual_image" width="14px" *ngIf="active_url === 'individual'">
    </div>
    <div class="link-div-column2--stat-menu text--stat-menu" [ngClass]="{'active--stat-menu': active_url === 'individual'}">
      Индивид. данные
    </div>
  </div>
</div>
